const trimTrailingSlash = (value) => value.replace(/\/+$/, "");

const isLocalhostHost = (hostname) =>
  hostname === "localhost" ||
  hostname === "127.0.0.1" ||
  hostname === "::1";

const resolvePublicUrl = () => {
  if (typeof window !== "undefined" && window?.location?.origin) {
    if (isLocalhostHost(window.location.hostname)) {
      return trimTrailingSlash(window.location.origin);
    }
  }

  const raw = process.env.REACT_APP_PUBLIC_URL;
  if (typeof raw === "string" && raw.trim()) {
    return trimTrailingSlash(raw.trim());
  }

  if (typeof window !== "undefined" && window?.location?.origin) {
    return trimTrailingSlash(window.location.origin);
  }

  return "https://synergycoinx.com";
};

export const APP_PUBLIC_URL = resolvePublicUrl();

export const buildJoinUrl = (code) => {
  if (!code) {
    return undefined;
  }

  return `${APP_PUBLIC_URL}/join/${code}`;
};
